import { MobXProviderContext } from 'mobx-react'
import { useContext } from 'react'
import RootStore from '../stores/RootStore'

export function useStore<Store = RootStore>() {
	const wrap: { rootStore?: Store } = useContext(MobXProviderContext)
	return wrap.rootStore
}
